import { AfterViewInit, Component, ElementRef, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonServiceService } from 'src/app/pages/services/common-service.service';
import { SnackBarComponent } from 'src/app/shared/snack-bar/snack-bar.component';
import { ConfirmationDialogComponent } from '../user-management/confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'app-communications',
  templateUrl: './communications.component.html',
  styleUrls: ['./communications.component.scss']
})
export class CommunicationsComponent implements OnInit, OnChanges, AfterViewInit {

  constructor(private commonService: CommonServiceService, private snackBar: MatSnackBar, public dialog: MatDialog) {
    this.accordionBody = new ElementRef(null); // Initialize with a default value
  }
  itemSelected = false;
  commentMsg = '';
  msgHighlighted = false;
  msgDeleted = false;
  dialogRef: any;
  msgUpdated = false;
  selectedMatIndex = 0;
  userData: any = JSON.parse(sessionStorage.getItem('userdata') || '{}');

  pageAction = JSON.parse(sessionStorage.getItem('userPermission') || '[]');
  currentAction: any;
  @ViewChild('accordionBody', { static: false }) accordionBody: ElementRef;

  messageStatus = {
    Replied: '1',
    Pending: '2',
    Rejected: '3'
  };
  messageLineItemDetails: any = [];


  timeline = [{
    action : 'Our company starts its operations',
    date : '11 March 2020',
    status : 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Sit necessitatibus adipisci, ad alias, voluptate pariatur officia repellendus repellat inventore fugit perferendis totam dolor voluptas et corrupti distinctio maxime corporis optio?'
  },
  {
    action : 'First customer',
    date : '19 March 2020',
    status : 'Quisque ornare dui nibh, sagittis egestas nisi luctus nec. Sed aliquet laoreet sapien, eget pulvinar lectus maximus vel. Phasellus suscipit porta mattis.'
  },
];
  ngOnChanges(changes: SimpleChanges): void {

  }
  ngOnInit(): void {
    this.sendReplyStatus('communicationmapper', 'create');
  }


  ngAfterViewInit(): void {

  }

  setApplyFiltr(event: any): void {
    if (event?.id){
      this.itemSelected = true;
    }
    else{
      this.itemSelected = false;
    }

  }
  recievedData(event: any): void {
    if (Object.keys(event).length){
      this.itemSelected = true;
    }
    this.messageLineItemDetails = event;
    this.msgDeleted = false;
    this.msgUpdated = false;

    setTimeout(() => {
      const accordionScroll = document.getElementById('accordionBody');
      if (!accordionScroll) {
        return;
      }

      accordionScroll.scrollTop += 2000;

    }, 2000);

  }

  tabSwitched(event: any): void {
    if (event){
      this.itemSelected = !event;
    }
  }

  replyStatus(status: string): void {
    this.msgUpdated = false;
    /*notifying message status constants as per backend
     Message_Status: {
       Replied: '1',
       Pending: '2',
       Rejected: '3'
     }*/
    let statusForMessage: any;
    switch (status) {
      case 'replied':
        statusForMessage = 1;
        break;

      case 'pending':
        statusForMessage = 2;
        break;

      case 'reminder':
        statusForMessage = 3;
        break;

      default:
        break;
    }

    const payload = {
      communication_id: this.messageLineItemDetails.id,
      message: this.commentMsg,
      statusForMessage,
      createdBy: this.messageLineItemDetails.createdBy,
      logCreatedBy: this.userData?.id
    };

    this.commonService.communicationmapper(payload).subscribe((res: any) => {
      if (res.success){
        this.commentMsg = '';
        this.msgUpdated = true;
        this.openSnackBar(['Updated Successfully !'], 3000);
      }
    });
  }

  openSnackBar(data: string[], duration: number): void {
    this.snackBar.openFromComponent(SnackBarComponent, { data, duration });
  }

  actionsOnChat(status: any): void {
    this.msgHighlighted = false;
    this.msgDeleted = false;

    if (status === 'highlight'){
      this.messageLineItemDetails.is_highlight = !this.messageLineItemDetails?.is_highlight;
    }


    if (status === 'delete'){
      const message = 'Are you sure want to delete this message ?';
      this.dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        data: {
          message,
          buttonText: {
            ok: 'Yes',
            cancel: 'No',
          },
        },
      });

      this.dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed){
          this.itemSelected = false;
          this.communicationActionUpdate(status);
        }
      });
    }else{
      this.communicationActionUpdate(status);
    }
  }

  communicationActionUpdate(status: any): void {
    const payload = {
      subject: this.messageLineItemDetails?.subject,
      message: this.messageLineItemDetails?.message,
      sender_id: this.messageLineItemDetails?.sender_id,
      receiver_id: this.messageLineItemDetails?.receiver_id,
      createdBy: this.messageLineItemDetails?.createdBy,
      is_highlight: this.messageLineItemDetails?.is_highlight,
      isActive : status === 'delete' ? false : true
    };
    this.commonService.communicationUpdate(this.messageLineItemDetails.id, payload).subscribe((res: any) => {
      if (res.success) {

        if (status === 'highlight') {
            this.msgHighlighted = true;
            if (res.data.is_highlight){
              this.openSnackBar(['Message Highlighted !'], 3000);
            }else{
              this.openSnackBar(['Message Unhighlighted !'], 3000);
            }
        }else{
            this.msgDeleted = true;
            this.openSnackBar(['Message Deleted Successfuly !'], 3000);
        }
      }
    });
  }

  hasActionTrueForModel(modelName: string= '', key: string= ''): boolean {
    // Find the object with the specified modelName
    if (this.pageAction && this.pageAction[0] && this.pageAction[0].authenicationJson){
    const modelObject = this.pageAction[0].authenicationJson.find((obj: any) => obj.model === modelName);

    // If the object is found and it has an authentication array
    if (modelObject && Array.isArray(modelObject.authentication)) {
        // Check if any action is true in the authentication array
        return modelObject.authentication.some((auth: any) => auth.isAction === true);
    }
  }

    // If the object is not found or it does not have an authentication array
    return false;
}

sendReplyStatus(modelName: any, key: any): void {
  if (key === 'create'){
    const currentModelName = this.pageAction[0]?.authenicationJson.find((ele: any) => ele?.model === modelName);
    currentModelName.authentication.forEach((data: any) => {
      if ( data?.key === key){
        this.currentAction =  data?.isAction;
      }
    });
  }
}

tabWiseData(event: any): void {
  this.selectedMatIndex = event?.index;
}

}
